import React, { useState, useEffect } from "react";
import axios from "axios";
import {
  Box,
  Typography,
  CircularProgress,
  Modal
} from "@mui/material";
import { BiErrorCircle } from "react-icons/bi";
import { FaRegCircleCheck } from "react-icons/fa6";
import { useUserAdmin } from "../../../admin/UserContext";
import { IoClose } from "react-icons/io5";
/* import diseño */
import { SeleccionDiseño } from "./SetCrearProducto/Diseño";
import { DiseñoSeleccionUno } from "./SetCrearProducto/SelecionUno";
import { DiseñoDos } from "./SetCrearProducto/SelecionDos";
import { DiseñoSelecionTres } from "./SetCrearProducto/SelecionTres";
import { DiseñoSelecionCuatro } from "./SetCrearProducto/SelecionCuatro";
import { DiseñoSelecionCinco } from "./SetCrearProducto/SelecionCinco";

const coloresDisponibles = [
  "#1A425B",
  "#FFFFFF",
  "#00A69E",
  "#6A3090",
  "#FFA457",
];

const TipoProducto = [
  "FREE STANDING",
  "TABLE TOP",
  "ACCESORIOS",
  "TELEMETRÍA",
  "UNIDADES DE CONTROL",
  "MEDIDAS DE VASOS",
  "CASIA",
  "CASIA LOCKERS"
];

export const CrearProductos = ({ onclose, fetchSliders }) => {
  const { Token } = useUserAdmin();
  const [step, setStep] = useState(1);
  const [loading, setLoading] = useState(false);
  const backendURL = process.env.REACT_APP_BACKEND_URL;
  const [successAlertOpen, setSuccessAlertOpen] = useState(false);
  const [errorAlertOpen, setErrorAlertOpen] = useState(false);
  const [enviandoAlert, setEnviandoAlert] = useState(false);
  const [alertMessage, setAlertMessage] = useState('');
  const [Categoria, setCategoria] = useState([]);
  const [formData, setFormData] = useState({
    categoria_id: '',
    tipo_producto: '',
    color: "",
    cantidad: '',
    diseño: '',
    pdf: null,
    imagen_producto: null,
    logo_empresa_maquina: null,
    imagen_dispositivo: null,
    imagen_dispositivo1: null,
    imagen_dispositivo2: null,
    imagen_dispositivo3: null,
    imagen_dispositivo4: null,
    imagen_dispositivo5: null,
    imagen_dispositivo6: null,
    imagen_dispositivo7: null,
    logo_dispositivo: null,
    logo_dispositivo1: null,
    titulo_maquina: '',
    nombre_maquina: '',
    titulo_vision: '',
    descripcion_vision: '',
    texto_innovacion: '',
    caracteristica: '',
    caracteristica1: '',
    caracteristica2: '',
    caracteristica3: '',
    caracteristica4: '',
    caracteristica6: '',
    caracteristica7: '',
    caracteristica8: '',
    caracteristica9: '',
    caracteristica10: '',
    beneficio: '',
    beneficio1: '',
    beneficio2: '',
    beneficio3: '',
    beneficio4: '',
    beneficio5: '',
    beneficio6: '',
    capacidad: '',
    capacidad1: '',
    capacidad2: '',
    capacidad3: '',
    capacidad4: '',
    capacidad5: '',
    capacidad6: '',
    capacidad7: '',
    capacidad8: '',

  });

  const handleFileChange = (e, name) => {
    const file = e.target.files[0];
    setFormData((prev) => ({ ...prev, [name]: file }));
  };

  const handleInputChange = (e) => {
    const { name, value } = e.target;
    setFormData(prev => ({
      ...prev,
      [name]: value
    }));
  };
  const handleSeleccionarDiseño = (id) => {
    if (!id) return;
    setFormData(prev => ({
      ...prev,
      diseño: id
    }));
    handleNextStep();
  };
  const handleNextStep = () => {
    setStep(step + 1);
  };

  useEffect(() => {
    const fetchCategoria = async () => {
      try {
        const response = await axios.get(`${backendURL}/api/all/producto/home`, {
          headers: {
            Authorization: `Bearer ${Token}`,
          },
        });
        setCategoria(response.data.data);
      } catch (error) {
        console.error("Error al obtener categorías:", error);
      }
    };

    if (Token) {
      fetchCategoria();
    }
  }, [Token, backendURL]);



  const handleSubmit = async (e) => {
    e.preventDefault();
    setEnviandoAlert(true)
    const data = new FormData();

    // Campos de texto
    data.append("categoria_id", formData.categoria_id);
    data.append("tipo_producto", formData.tipo_producto);
    data.append("color", formData.color);
    data.append("cantidad", formData.cantidad); // <-- ESTE NO LO ESTABAS ENVIANDO
    data.append("diseño", formData.diseño);
    data.append("descripcion_tipo_producto", formData.descripcion_tipo_producto);
    // Campos tipo texto adicionales
    data.append("titulo_maquina", formData.titulo_maquina);
    data.append("nombre_maquina", formData.nombre_maquina);
    data.append("titulo_vision", formData.titulo_vision);
    data.append("descripcion_vision", formData.descripcion_vision);
    data.append("texto_innovacion", formData.texto_innovacion);

    // Características
    data.append("caracteristica", formData.caracteristica);
    data.append("caracteristica1", formData.caracteristica1);
    data.append("caracteristica2", formData.caracteristica2);
    data.append("caracteristica3", formData.caracteristica3);
    data.append("caracteristica4", formData.caracteristica4);
    data.append("caracteristica6", formData.caracteristica6);
    data.append("caracteristica7", formData.caracteristica7);
    data.append("caracteristica8", formData.caracteristica8);
    data.append("caracteristica9", formData.caracteristica9);
    data.append("caracteristica10", formData.caracteristica10);

    // Beneficios
    data.append("beneficio", formData.beneficio);
    data.append("beneficio1", formData.beneficio1);
    data.append("beneficio2", formData.beneficio2);
    data.append("beneficio3", formData.beneficio3);
    data.append("beneficio4", formData.beneficio4);
    data.append("beneficio5", formData.beneficio5);
    data.append("beneficio6", formData.beneficio6);

    // Capacidades
    data.append("capacidad", formData.capacidad);
    data.append("capacidad1", formData.capacidad1);
    data.append("capacidad2", formData.capacidad2);
    data.append("capacidad3", formData.capacidad3);
    data.append("capacidad4", formData.capacidad4);
    data.append("capacidad5", formData.capacidad5);
    data.append("capacidad6", formData.capacidad6);
    data.append("capacidad7", formData.capacidad7);
    data.append("capacidad8", formData.capacidad8);

    const camposConImagenes = [
      'pdf',
      "imagen_producto",
      "logo_empresa_maquina",
      "imagen_dispositivo",
      "imagen_dispositivo1",
      "imagen_dispositivo2",
      "imagen_dispositivo3",
      "imagen_dispositivo4",
      "imagen_dispositivo5",
      "imagen_dispositivo6",
      "imagen_dispositivo7",
      "logo_dispositivo",
      "logo_dispositivo1",
    ];

    camposConImagenes.forEach((campo) => {
      if (formData[campo] instanceof File) {
        data.append(campo, formData[campo]);
      }
    });

    try {
      setLoading(true);
      await axios.post(`${backendURL}/api/crear/productos`, data, {
        headers: {
          Authorization: `Bearer ${Token}`,
          "Content-Type": "multipart/form-data"
        }
      });

      setAlertMessage("Se ha generado con éxito.");
      setEnviandoAlert(false)
      setSuccessAlertOpen(true);


    } catch (error) {
      console.error(error);
      setAlertMessage("Error al crear.");
      setErrorAlertOpen(true);
      setEnviandoAlert(false)
    } finally {
      setLoading(false);
      await fetchSliders()
      setTimeout(() => {
        setSuccessAlertOpen(false);
        setEnviandoAlert(false)
        setErrorAlertOpen(false);
        onclose();

      }, 3000);
    }
  };


  return (
    <Box p={3}>


      {step === 1 && (
        <Box>
          <Typography variant="h5" gutterBottom sx={{ color: '#585857' }}>
            Crear Nuevo Producto
          </Typography>
          <SeleccionDiseño
            onSeleccionarDiseño={handleSeleccionarDiseño}
            diseñoSeleccionado={formData.diseño}
          />
        </Box>
      )}
      {step === 2 && formData.diseño === 1 && (
        <DiseñoSeleccionUno
          TipoProducto={TipoProducto}
          coloresDisponibles={coloresDisponibles}
          loading={loading}
          Categoria={Categoria}
          formData={formData}
          handleSubmit={handleSubmit}
          handleInputChange={handleInputChange}
          handleFileChange={handleFileChange}
        />
      )}
      {step === 2 && formData.diseño === 2 && (
        <DiseñoDos
          TipoProducto={TipoProducto}
          coloresDisponibles={coloresDisponibles}
          loading={loading}
          Categoria={Categoria}
          formData={formData}
          handleSubmit={handleSubmit}
          handleInputChange={handleInputChange}
          handleFileChange={handleFileChange}
        />
      )}
      {step === 2 && formData.diseño === 3 && (
        <DiseñoSelecionTres
          TipoProducto={TipoProducto}
          coloresDisponibles={coloresDisponibles}
          loading={loading}
          Categoria={Categoria}
          formData={formData}
          handleSubmit={handleSubmit}
          handleInputChange={handleInputChange}
          handleFileChange={handleFileChange}
        />
      )}
      {step === 2 && formData.diseño === 4 && (
        <DiseñoSelecionCuatro
          TipoProducto={TipoProducto}
          coloresDisponibles={coloresDisponibles}
          loading={loading}
          Categoria={Categoria}
          formData={formData}
          handleSubmit={handleSubmit}
          handleInputChange={handleInputChange}
          handleFileChange={handleFileChange}
        />
      )}
      {step === 2 && formData.diseño === 5 && (
        <DiseñoSelecionCinco
          TipoProducto={TipoProducto}
          coloresDisponibles={coloresDisponibles}
          loading={loading}
          Categoria={Categoria}
          formData={formData}
          handleSubmit={handleSubmit}
          handleInputChange={handleInputChange}
          handleFileChange={handleFileChange}
        />
      )}



      <Modal open={successAlertOpen} onClose={() => setSuccessAlertOpen(false)}>
        <Box sx={modalStyle}>
          <section className="closemodal" onClick={() => setSuccessAlertOpen(false)}>
            <IoClose style={{ color: '#585857' }} />
          </section>
          <section style={{ textAlign: 'center' }}>
            <FaRegCircleCheck style={{ color: 'green', fontSize: '2rem', marginBottom: '1rem' }} />
            <p>{alertMessage}</p>
          </section>
        </Box>
      </Modal>

      {/* Modal de error */}
      <Modal open={errorAlertOpen} onClose={() => setErrorAlertOpen(false)}>
        <Box sx={modalStyle}>
          <section className="closemodal" onClick={() => setErrorAlertOpen(false)}>
            <IoClose />
          </section>
          <section style={{ textAlign: 'center' }}>
            <BiErrorCircle style={{ color: 'red', fontSize: '2rem', marginBottom: '1rem' }} />
            <p>{alertMessage}</p>
          </section>
        </Box>
      </Modal>

      {/* Modal de progreso */}
      <Modal open={enviandoAlert} onClose={() => setEnviandoAlert(false)}>
        <Box sx={modalStyle}>
          <section className="closemodal" onClick={() => setErrorAlertOpen(false)}>
            <IoClose />
          </section>
          <section style={{ textAlign: 'center', padding: '1rem' }}>
            <CircularProgress style={{ color: '#694B81' }} />
            <p>Procesando solicitud...</p>
          </section>
        </Box>
      </Modal>
    </Box>
  );
};

const modalStyle = {
  position: 'absolute',
  top: '50%',
  left: '50%',
  transform: 'translate(-50%, -50%)',
  width: 400,
  bgcolor: '#ffff',
  border: '0px solid #000',
  boxShadow: 24,
  p: 4,
  borderRadius: '10px'
};

